
import moment_ from 'moment';
import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';import { Router } from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {FileManagementService} from '@core/services/file-management.service';
 @Injectable({
  providedIn: 'root',
})

export class TranslationCommandHandler implements IPlatformCommandHandler {
  moment: any;
  constructor(
    private commandService: CommandService,
    private router: Router,
    private dialogService: DialogService,
    protected fileManagementService: FileManagementService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService
  ) {}
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          if( commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand'] , null);
          }
          if (commandResponse.fieldValues['DownloadUrl']) {
            this.downloadTranslatedFile(commandResponse.fieldValues['DownloadUrl'], commandResponse.fieldValues['FileName']);
          }
        },
        error => {
          let errorMessage = 'Download failed!';
          if (error && error.fieldValues && error.fieldValues['SnackBarMessage']) {
            errorMessage = error.fieldValues['SnackBarMessage'];
          }
        this.snackBarService.showError(errorMessage);
          this.fuseSplashScreenService.hide();
        });
    }
    return false;
  }

   private downloadTranslatedFile(downloadUrl: string, fileName: string) {
     this.fileManagementService.downloadOneTimeSignedUrl(downloadUrl, fileName);
   }
}
